module.exports = __webpack_public_path__ + "img/1285-william-arthur-ward-quotes.6881933a.jpeg";